// extracted by mini-css-extract-plugin
var _1 = "gBXgTi1osI50bpU564Sb";
var _2 = "xn40D8QEul8E3pmgyRmH";
var _3 = "JRdd7OvbXZS3P3sVyeYV";
var _4 = "m5v0JqUnHUY7NTXlVjar";
export { _1 as "noRows", _2 as "noRowsText", _3 as "rowStyle", _4 as "tableContainer" }
